import { render, staticRenderFns } from "./LoyaltyRewards.vue?vue&type=template&id=2c2ed46b&scoped=true&"
import script from "./LoyaltyRewards.vue?vue&type=script&lang=ts&"
export * from "./LoyaltyRewards.vue?vue&type=script&lang=ts&"
import style0 from "./LoyaltyRewards.vue?vue&type=style&index=0&id=2c2ed46b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ed46b",
  null
  
)

export default component.exports